import type { AddToProductImage, AddToProductTarget } from '../types'

interface DndLike {
  active: { data: { current?: { image?: AddToProductImage } } }
  over: { data: { current?: Record<string, unknown> } } | null
}

export function resolveDrop(
  e: DndLike,
): { image: AddToProductImage; target: AddToProductTarget } | null {
  const image = e.active.data.current?.image
  const d = e.over?.data.current
  if (!image || !d) return null
  if (d.target === 'ai_reference' && typeof d.slot === 'number') {
    return { image, target: { type: 'ai_reference', slot: d.slot } }
  }
  if (
    d.target === 'channel' &&
    typeof d.channelId === 'string' &&
    typeof d.slot === 'number'
  ) {
    return {
      image,
      target: { type: 'channel', channelId: d.channelId, slot: d.slot },
    }
  }
  return null
}
